/**
 * Accept array of Promises and waits for the finish
 * @param list {function[]} array of functions that returns Promise
 */

export function asyncRunner (list) {
  async function runner () {
    for (let i = 0; i < list.length; i++) {
      await list[i]()
    }
  }
}

/**
 * Check whether the pointed file does exists
 * @param url
 * @return {boolean}
 */
export function fileCheck (url) {
  let http = new XMLHttpRequest()
  http.open('HEAD', url, false)
  http.send()
  return http.status !== 404
}

/**
 * Check whether the variable is object
 */

export function isObject(item) {
  return (item && typeof item === 'object' && !Array.isArray(item));
}

export function isJsonString(str) {
  if(str === undefined || str.length === 0 || str[0] !== "{")
    return false

  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}

/**
 *  Get rid of diacritics in a string
 * @param str String
 * @returns String
 */
export function removeDiacritics (str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

export function sortAlphaNum (a, b) {
  const reA = /[^a-zA-Z]/g
  const reN = /[^0-9]/g
  const aA = a.replace(reA, '')
  const bA = b.replace(reA, '')
  if (aA === bA) {
    let aN = parseInt(a.replace(reN, ''), 10)
    let bN = parseInt(b.replace(reN, ''), 10)
    return aN === bN ? 0 : aN > bN ? 1 : -1
  } else {
    return aA > bA ? 1 : -1
  }
}


export function rgbToHex(r, g, b) {
  return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

export function HexToRbg(hex, alpha = false) {
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    let c = hex.substring(1).split('')
    if (c.length === 3) c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    c = "0x" + c.join('')
    return (alpha ? 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + alpha + ")" : [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(','))
  }
}

export function isHexColor (str) {

  return /^#([0-9A-F]{3}){1,2}$/i.test(str)

}

export function countDecimals (value) {

  if(Math.floor(value) === value) return 0

  return value.toString().split(".")[1].length || 0
}

export function getSize (bytes = 0) {

  if (bytes === 0) return '0 Byte';

  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const size = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));

  return Math.round(bytes / Math.pow(1024, size), 2) + String.fromCharCode(160) + sizes[size];

}

/**
 * Check whether the event is fired when ctrl key is down
 * @param e
 * @returns {boolean}
 */
export function isCtrlDown (e) {
  let isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0
  return (isMac && e.metaKey || /* On win*/ !isMac && e.ctrlKey)
}

export function capitalizeFirstLetter (str) {

  return (str.charAt(0).toUpperCase() + str.slice(1))

}

export function isURL (str) {

  const regexp = /(ftp|http|https):\/\/(\w+:?\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;

  return regexp.test(str)

}

export function abbreviateNumber(value) {

  let newValue = value

  if (value >= 1000) {

    const suffixes = ['', 'k', 'm', 'b', 't']
    const suffixNum = Math.floor(('' + value).length / 3)

    let shortValue = ''

    for (let precision = 2; precision >= 1; precision--) {

      shortValue = parseFloat( (suffixNum != 0 ? (value / Math.pow(1000, suffixNum) ) : value).toPrecision(precision))

      const dotLessShortValue = (shortValue + '').replace(/[^a-zA-Z 0-9]+/g, '')

      if (dotLessShortValue.length <= 2) break

    }

    if (shortValue % 1 != 0)  shortValue = shortValue.toFixed(1)

    newValue = shortValue+suffixes[suffixNum]

  }

  return newValue

}

export function updateParamsInURL(url, key, values = []) {

  url = new URL(url)

  const params = new URLSearchParams(url.search)

  params.forEach((value, param) => {
    if (param.startsWith(key)) {
      params.delete(param)
    }
  })

  values.forEach((value, index) => {
    params.append(`${key}[]`, value)
  })

  url.search = params.toString()

  return url.toString()

}

export function replaceAll (str, obj) {

  for(let x in obj) {
    if(obj.hasOwnProperty(x)) {
      str = str.replace(new RegExp(`\\${x}`, 'gi'), obj[x])
    }
  }

  return str

}

export function getFormattedNumber (value, delimiter = ' ') {

  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, delimiter)

}
